import { Box, Stack, Typography } from '@mui/material'
import React from 'react'

export interface LegendItem {
  color: string
  label: string
}

const Legend = ({items}: {items: LegendItem[]}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
      <Stack direction="row" spacing={3} flexWrap="wrap" justifyContent="center">
        {items.map((item, index) => (
          <Stack key={index} direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: item.color
              }}
            />
            <Typography sx={{ fontSize: '12px' }}>
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}

export default Legend